<template>
    <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Static Example</h3>
          </div>
          <div class="card-body">
            <div class="modal-dialog static-modal modal-lg mt-0 mb-0" id="example" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog mt-0 mb-0" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h3 class="modal-title">New message</h3>
                    <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                    <button class="btn btn-primary ms-2" type="button">Send message</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>